export default __webpack_public_path__ + "static/home-header-3fc325bb848f3c2d74b1c9b261fb5fd3.jpeg";